<template>
  <span class="sf-indicator-new__container" :class="positionalClasses">
    <span class="sf-indicator-new__icon"></span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
}

const { position } = defineProps<Props>()

const positionalClasses = computed(() => {
  return {
    'sf-indicator-new__container--absolute': !!position,
    'sf-indicator-new__container--top-left': position === 'top-left',
    'sf-indicator-new__container--top-right': position === 'top-right',
    'sf-indicator-new__container--bottom-left': position === 'bottom-left',
    'sf-indicator-new__container--bottom-right': position === 'bottom-right',
  }
})
</script>
<style lang="scss" scoped>
@import 'sf-indicator-new';
</style>
